import { render, staticRenderFns } from "./RightBlock.vue?vue&type=template&id=c98af276&scoped=true&"
import script from "./RightBlock.vue?vue&type=script&lang=ts&"
export * from "./RightBlock.vue?vue&type=script&lang=ts&"
import style0 from "./RightBlock.vue?vue&type=style&index=0&id=c98af276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98af276",
  null
  
)

export default component.exports